import { render, staticRenderFns } from "./ReviewLinksList.vue?vue&type=template&id=73ffa7b3&scoped=true&"
import script from "./ReviewLinksList.vue?vue&type=script&lang=ts&"
export * from "./ReviewLinksList.vue?vue&type=script&lang=ts&"
import style0 from "./ReviewLinksList.vue?vue&type=style&index=0&id=73ffa7b3&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "73ffa7b3",
  null
  
)

export default component.exports